export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN = '/admin';
export const ADMIN_DETAILS = '/admin/:id';
export const ABOUT = '/about';
export const THEMISSION ='/themission';
export const YOURCOURSES ='/yourcourses';
export const OURTEACHING ='/ourteaching';
export const PRICESANDDATES ='/pricesanddates';
export const REGISTERNOW ='/register';
